import api from 'api'
import { fetchWithToken } from 'utils'

const upgrade = async (organizationId: string | null | undefined, campaignId: string) =>
  await fetchWithToken({
    method: 'POST',
    resource: api.ccConfig,
    path: `organizations/${organizationId}/free-trial/upgrade`,
    useV5: false,
    useVersion: 'v2',
    options: {
      body: JSON.stringify({ campaignId }),
    },
  }).catch((err: Error) => {
    // Something wrong happened during the fetch
    console.error(err.toString())
  })

export default upgrade
